import gsap from "gsap";
import { Localizer } from "shared/localization";
import { LocElementsStorage, LanguageStorage } from "shared/storages";

export class LanguageService {
    private static defaultLanguge = {
        slide: 0,
        translate: 0,
        languages: [],
        currentLanguage: 'en',
        canClick: true,
        keys: null,
    };
    public static currentData = {
        slide: 0,
        translate: 0,
        languages: [],
        currentLanguage: 'en',
        canClick: true,
        keys: null,
    };

    public static setCurrentLanguage() {
        const languages = Localizer.languages;


        for (const key in languages) {
            if (languages.hasOwnProperty(key)) {
                if (languages.hasOwnProperty(key) && languages[key].name === this.currentData.currentLanguage) {

                    this.currentData.keys = languages[key].data;

                }
            }
        }
    }

    public static setDefaultLanguage(): void {
        const languages = Localizer.languages;

        this.defaultLanguge.keys = languages['en'].data;
    }

    public static getTranslation(key: string): string {
        const keys = this.currentData.keys;
        const defaultLanguage = this.defaultLanguge.keys;
        let translation = keys[key];

        if (!translation) {
            translation = defaultLanguage[key];
        }

        return translation;
    }

    public static init(): void {
        const languageSlider = document.getElementById('slider_content');
        const language_left = document.getElementById('language_left');
        const language_right = document.getElementById('language_right');
        const languages = Localizer.languages;
        let langularNum: number = 0;

        for (const key in languages) {
            if (languages.hasOwnProperty(key)) {
                langularNum += 1;
                const language = languages[key].name;
                const div = document.createElement('div');
                const span = document.createElement('span');
                span.innerHTML = language;
                div.classList.add('slide');
                div.appendChild(span);
                languageSlider.appendChild(div);

                this.currentData.languages.push(language);

            }

            this.changeHtmlLanguage();
            this.changeGameLanguage();
            this.changePlaceholders();
        }

        language_left.addEventListener('click', () => {
            if (this.currentData.slide === 0 || !this.currentData.canClick) {
                return;
            }

            this.currentData.slide -= 1;
            const translate = this.currentData.translate + 100;
            this.currentData.canClick = false;
            this.changeSlide(translate);
        });

        language_right.addEventListener('click', () => {
            if (this.currentData.slide === langularNum - 1 || !this.currentData.canClick) {
                return;
            }

            this.currentData.slide += 1;
            const translate = this.currentData.translate - 100;
            this.currentData.canClick = false;
            this.changeSlide(translate);
        })

        let touch_x;
        languageSlider.addEventListener('touchstart', (e) => {
            touch_x = e.changedTouches[e.changedTouches.length - 1].clientX;

        })

        languageSlider.addEventListener('mousedown', (e) => {
            touch_x = e.pageX;
        })

        languageSlider.addEventListener('touchend', (e) => {
            let touchEnd_x = e.changedTouches[e.changedTouches.length - 1].clientX;
            if (touchEnd_x < touch_x && e.type == 'touchend' && Math.abs(touch_x - touchEnd_x) > 3) {
                if (this.currentData.slide < langularNum - 1 || !this.currentData.canClick) {
                    const translate = this.currentData.translate - 100;
                    this.currentData.canClick = false;
                    this.currentData.slide += 1;
                    this.changeSlide(translate)
                }
            }
            else if (touchEnd_x > touch_x && e.type == 'touchend' && Math.abs(touch_x - touchEnd_x) > 3) {
                if (this.currentData.slide > 0 || !this.currentData.canClick) {
                    this.currentData.slide -= 1;
                    const translate = this.currentData.translate + 100;
                    this.currentData.canClick = false;
                    this.changeSlide(translate);
                }
            }
        })

        languageSlider.addEventListener('mouseup', (e) => {
            let touchEnd_x = e.pageX;
            if (touchEnd_x < touch_x && e.type == 'mouseup' && Math.abs(touch_x - touchEnd_x) > 3) {
                if (this.currentData.slide < langularNum - 1 || !this.currentData.canClick) {
                    const translate = this.currentData.translate - 100;
                    this.currentData.canClick = false;
                    this.currentData.slide += 1;
                    this.changeSlide(translate)
                }
            }
            else if (touchEnd_x > touch_x && e.type == 'mouseup' && Math.abs(touch_x - touchEnd_x) > 3) {
                if (this.currentData.slide > 0 || !this.currentData.canClick) {
                    this.currentData.slide -= 1;
                    const translate = this.currentData.translate + 100;
                    this.currentData.canClick = false;
                    this.changeSlide(translate);
                }
            }
        })


    }

    private static changeSlide(translate): void {
        const languageSlider = document.getElementById('slider_content');

        gsap.to(this.currentData, {
            translate: translate, duration: 0.3, onUpdate: () => {
                languageSlider.style.transform = `translateX(${this.currentData.translate}%)`;
            }, onComplete: () => {
                this.currentData.canClick = true;
            }
        })
        this.currentData.currentLanguage = this.currentData.languages[this.currentData.slide];
        LanguageStorage.language = this.currentData.currentLanguage;

        this.changeHtmlLanguage();
    }

    public static changeHtmlLanguage(): void {
        let data = this.currentData.keys;
        const languages = Localizer.languages;

        if (data) {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    const elements = document.getElementsByClassName(key + '');

                    for (let i = 0; i < elements.length; i++) {
                        const el = elements[i];

                        el.innerHTML = this.getTranslation(key);
                    }
                }
            }
        }
    }

    public static changeGameLanguage(): void {
        const languages = Localizer.languages;
        const pixiElements = LocElementsStorage.elements;

        let data = this.currentData.keys;

        if (data && pixiElements) {
            for (const key in data) {

                for (let i = 0; i < pixiElements.length; i++) {
                    if (pixiElements[i][key]) {
                        pixiElements[i][key].text = this.getTranslation(key);
                    }
                }
                // if (data.hasOwnProperty(key)) {
                //     const elements = document.getElementsByClassName(key + '');

                //     for (let i = 0; i < elements.length; i++) {
                //         const el = elements[i];

                //         el.innerHTML = data[key];
                //     }
                // }
            }
        }
    }

    private static changePlaceholders(): void {
        let data = null;
        const substr = 'placeholder';
        const languages = Localizer.languages;
        for (const key in languages) {
            if (languages.hasOwnProperty(key) && languages[key].name === this.currentData.currentLanguage) {
                data = languages[key].data;
            }
        }

        if (data) {
            const changed = [];
            for (const key in data) {
                const keyStr = `${key}`;
                const text = this.getTranslation(key);
                if (text && key.includes(substr) && changed.indexOf(key) === -1) {
                    changed.push(key)
                    const elements = document.getElementsByClassName(key + '') as any;

                    for (let i = 0; i < elements.length; i++) {
                        const el = elements[i];

                        el.placeholder = this.getTranslation(key);
                    }
                }
            }

            for (const key in this.defaultLanguge.keys) {
                const keyStr = `${key}`;
                const text = this.getTranslation(key);
                if (text && key.includes(substr) && changed.indexOf(key) === -1) {
                    changed.push(key)
                    const elements = document.getElementsByClassName(key + '') as any;

                    for (let i = 0; i < elements.length; i++) {
                        const el = elements[i];

                        el.placeholder = this.getTranslation(key);
                    }
                }
            }
        }
    }
}